export default "__VITE_ASSET__BzMfJ2pE__"